import React, { Component } from 'react';
import store from '../../store';
import {HandleSubmit} from '../../func/HandleSubmit';
import DeleteKala from '../Kala/DeleteKala';
import { EditFunc, ShowEditForm } from '../Kala/EditKala';
import AddKala from "../Kala/AddKala";

class ListKala extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TableRow: [],
            Validation: {},
            Loading: true,
            TableOfKala: {},
            show_edit_row: [],
        };
        this.GetTableOfKala = this.GetTableOfKala.bind(this);
    }
    async GetTableOfKala() {
        var response_info = await HandleSubmit('kala/getlist', '');
        this.setState({
            TableOfKala: (response_info),
        });
        console.log("response_info", response_info);
    }
    CreateRow() {
        //myRef = React.createRef();
        for (let item of this.state.TableOfKala) {
            this.state.TableRow.push({
                Item: item,
                Row: <React.Fragment>
                    <td>{item.row}</td>
                    <td>{item.kala_code}</td>
                    <td>{item.kala_name}</td>
                    <td><button className="btn btn-outline-danger" onClick={() => (
                        this.DeleteRow(item.kala_code)
                    )}>حذف </button></td>
                    <td><button className="btn btn-outline-warning" onClick={() => (
                        this.EditRow(item.row - 1, true)
                    )}>ویرایش </button></td>
                    <td></td>
                </React.Fragment>
            });
            this.state.show_edit_row[item.row - 1] = 0;
        }
        this.setState({
            TableRow: this.state.TableRow,
            show_edit_row: this.state.show_edit_row
        });
    }
    async EditRow(index, stat) {
        if (stat == true) {
            this.state.show_edit_row[index] = 1;
        }
        else {
            this.state.show_edit_row[index] = 0;
        }
        this.setState({
            show_edit_row: this.state.show_edit_row
        });
    }
    async DeleteRow(item) {
        await DeleteKala(item);
        await this.InitList();
    }
    async InitList() {
        this.setState({
            Loading: true,
            TableRow: [],
        });
        await this.GetTableOfKala();
        this.CreateRow();
        this.setState({
            Loading: false
        });
    }
    async componentDidMount() {
        store.dispatch({ type: 'kala' });
        await this.InitList();
        console.log(this.state.show_edit_row);
    }
    render() {
        if (this.state.Loading) { return "Loading..." }
        return (
            <div>
                <AddKala initlist={() => this.InitList()} />
                <table className="table-responsive table-bordered table-striped" style={{ "textAlign": "center", "border": "4px solid rgba(0, 150, 255, 0.91)" }}>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>کدکالا</th>
                            <th>نام کالا</th>
                        </tr>
                        {this.state.TableRow.map(
                            (item, index) => (
                                <React.Fragment key={index}>
                                    <tr>{item.Row}</tr>
                                    {this.state.show_edit_row[index] === 0 ? null : <ShowEditForm index={item.Item}
                                        refresh={() => this.InitList()} cancelfunc={() => this.EditRow(index, false)} />}
                                </React.Fragment>
                            )
                        )}
                    </tbody>
                </table>
                {//<button className="btn btn-success" onClick={this.CheckValidation}>Valid</button>
                }
            </div >

        );
    }
}
export default (ListKala);







// WEBPACK FOOTER //
// ./src/pages/Kala/ListKala.js